import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Quote, ArrowRight } from "lucide-react";
import api from "../../lib/api";
import { Reveal } from "./Reveal";
import FullImage from "./FullImage";

export const ProverbOfDay = () => {
  const [proverb, setProverb] = React.useState(null);

  React.useEffect(() => {
    api.get("/proverbs/proverb-of-the-day").then((r) => setProverb(r.data)).catch(() => {});
  }, []);

  if (!proverb) return null;

  return (
    <section className="bg-forest text-cream grain-overlay" data-testid="proverb-of-day-section">
      <div className="max-w-4xl mx-auto px-6 py-24">
        <Reveal>
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="relative rounded-3xl border border-gold/30 bg-night/25 p-8 md:p-12 overflow-hidden"
            data-testid="proverb-of-day-card"
          >
            <Quote className="w-10 h-10 text-gold/50 mb-5" />
            <div className="flex items-center gap-2 mb-6">
              <p className="uppercase tracking-[0.25em] text-xs text-gold-soft">Proverb of the Day · Òwe</p>
              {proverb.theme && (
                <span className="text-[10px] uppercase tracking-widest border border-cream/25 rounded-full px-2.5 py-0.5 text-cream/60">
                  {proverb.theme}
                </span>
              )}
            </div>

            <p className="font-serif text-2xl md:text-3xl text-gold leading-snug mb-5" data-testid="proverb-of-day-yoruba">
              {proverb.yoruba}
            </p>
            {proverb.image && (
              <FullImage src={proverb.image} alt="" className="h-72 rounded-xl mb-6" testId="proverb-of-day-image" />
            )}
            {proverb.meaning && (
              <p className="text-cream/80 text-lg leading-relaxed mb-8">{proverb.meaning}</p>
            )}

            <Link
              to="/proverbs"
              data-testid="proverb-of-day-link"
              className="inline-flex items-center gap-2 text-sm font-semibold text-gold hover:text-gold-light transition-colors"
            >
              Explore all proverbs
              <ArrowRight className="w-4 h-4" />
            </Link>
          </motion.div>
        </Reveal>
      </div>
    </section>
  );
};

export default ProverbOfDay;
